import { Component, OnInit } from '@angular/core';
import { Address } from '../../_models/address';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from '../../_models/user';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-ao-seller',
  templateUrl: './create-ao-seller.component.html',
  styleUrls: ['./create-ao-seller.component.scss'],
})
export class CreateAoSellerComponent implements OnInit {
  companyName: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  sellerCode: string;
  password: string;
  statesList: any;
  citiesList: any;
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";

  constructor(private http: HttpClient, private router: Router, public user: User, private api: ApiIntegration, private g: Globals, private alertService: AlertService) {
    this.stateList();
    this.cityList();
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.zip).subscribe((data: any) => {
      this.city = data.city;
      this.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() {
  }

  typeFirstName() {
    this.statusText1 = "";
    if (this.firstName == '' || this.firstName === null || this.firstName === undefined || this.firstName === 'undefined') {
      this.statusText1 = 'Please enter First Name';
    }
  }

  typeLastName() {
    this.statusText2 = "";
    if (this.lastName == '' || this.lastName === null || this.lastName === undefined || this.lastName === 'undefined') {
      this.statusText2 = 'Please enter Last Name';
    }
  }

  typeMobile() {
    this.statusText3 = "";
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter Last Name';
    }
  }

  validateSellerCode() {
    this.statusText9 = "";
    if (this.sellerCode == '' || this.sellerCode === null || this.sellerCode === undefined || this.sellerCode === 'undefined') {
      this.statusText9 = 'Please enter Seller Code';
    }
  }

  validatePassword() {
    this.statusText10 = "";
    if (this.password == '' || this.password === null || this.password === undefined || this.password === 'undefined') {
      this.statusText10 = 'Please enter Password';
    }
  }

  validateMobile() {
    this.statusText3 = "";
    this.typeMobile();
    if (this.mobileNumber !== 'undefined') {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
        this.mobileNumber,
        { headers: header1 }).subscribe(data => {
          if (data['code'] == 200) {

          } else {
            if (data['code'] == 400) {
              this.statusText3 = data['message'];
            }
          }

        },
          (err: HttpErrorResponse) => {
            console.log(err);
            this.statusText3 = "Mobile Number  Exists";
          }
        )
    }
  }

  typeEmail() {
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
      return false;
    }
    return true;
  }

  validateEmail() {
    this.statusText4 = "";
    this.typeEmail();


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail?email=' + this.email + '&userType='+ 'USER',
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          if (data['code'] == 400) {
            this.statusText4 = data['message'];
          }
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText4 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  createAddress() {
    this.statusText5 = "";
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText5 = 'Please enter address 1';
      return false;
    }
  }

  createCity() {
    this.statusText6 = "";
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText6 = 'Please enter city';
      return false;
    }
  }

  createState() {
    this.statusText7 = "";
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText7 = 'Please enter state';
      return false;
    }
  }

  createZip() {
    this.statusText8 = "";
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText8 = 'Please enter ZIP';
      return false;
    } else if (this.zip.length != 6) {
      this.statusText8 = 'ZIP code must be minimum 6 digits';
      return false;
    }
  }

  createSeller() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCustomerSeller', {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "companyName": this.companyName,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "mobile": this.mobileNumber,
      "email": this.email,
      "sellerReferenceCode": this.sellerCode,
      "password": this.password,
      "address1": this.address1,
      "address2": this.address2,
      "city": this.city,
      "state": this.state,
      "zipCode": this.zip,
      "status": "ACTIVE"
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == "200") {
        this.router.navigate(['/admin/myAccountList/']);
        this.alertService.success('Seller', 'Created Successfully');
      } else {
        this.alertService.error(data['message']);
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }
}
